// Tri d'affichage des factures : de la plus récente à la plus ancienne selon la période
// facturée, puis la date de facture. Les numéros FAC-* et les dates de facture ne suivent
// pas forcément l'ordre des périodes quand des factures sont régularisées après coup.
const periodKey = (inv) => new Date(inv.period_start || inv.invoice_date || 0).getTime() || 0;
const dateKey = (inv) => new Date(inv.invoice_date || inv.created_at || 0).getTime() || 0;

export const sortInvoicesForDisplay = (invoices) =>
  [...(invoices || [])].sort((a, b) => (periodKey(b) - periodKey(a)) || (dateKey(b) - dateKey(a)));
